import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { LanguageService } from './core/i18n/language.service';
import { SeoService } from './core/seo/seo.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class App {
  private readonly router = inject(Router);
  private readonly seo = inject(SeoService);
  private readonly language = inject(LanguageService);

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.applyRouteSeoPolicy(event.urlAfterRedirects));
  }

  private applyRouteSeoPolicy(url: string): void {
    const path = url.split('?')[0] || '/';

    if (path === '/' || path === '/search') return;

    if (path.startsWith('/property/') || path.startsWith('/h/')) {
      this.seo.setNoIndex({
        title: this.language.translate('common.seo.loadingTitle'),
        follow: true,
      });
      return;
    }

    this.seo.setNoIndex({
      title: this.language.translate('common.seo.privateTitle'),
      follow: false,
    });
  }
}
